"use client";
import { Box, Heading, HStack } from "@chakra-ui/react";
import { PageBlockSimpleSectionHeader } from "lib/gcms";
import { mapButton } from "utils/map-button";

/**
 * A centered header with a title, subtitle, and buttons
 */
const SimplePageHeader = ({
  title,
  buttons,
  backgroundColor,
  textColor,
  children,
}: PageBlockSimpleSectionHeader) => {
  return (
    <Box
      as="section"
      pt={{ base: "10", md: "16" }}
      pb={{ base: "6", md: "10" }}
      bg={backgroundColor}
      color={textColor}
    >
      <Box
        maxW={{ base: "xl", md: "5xl" }}
        mx="auto"
        px={{ base: "6", md: "8" }}
      >
        <Box textAlign="center">
          {title && (
            <Heading
              as="h1"
              size="4xl"
              fontWeight="extrabold"
              maxW="48rem"
              mx="auto"
              lineHeight="1.2"
              letterSpacing="tight"
            >
              {title}
            </Heading>
          )}
          {children && (
            <Box my="4" maxW="xl" mx="auto">
              {children}
            </Box>
          )}
          {buttons && (
            <HStack mt={{ base: "4", md: "8" }} mx="auto" w="fit-content">
              {buttons.map((button, idx) =>
                mapButton(button, { key: idx, size: "lg" }),
              )}
            </HStack>
          )}
        </Box>
      </Box>
    </Box>
  );
};
export default SimplePageHeader;
